module.exports = __webpack_public_path__ + "img/mars-stroke-right.24eff2f1.svg";